/**
 * 最大触摸时间
 */
export const maxTouchTime: number = 200;

/**
 * 最大滑动切换图片距离
 */
export const maxMoveOffset: number = 40;

/**
 * 图片的间隔
 */
export const horizontalOffset: number = 20;

/**
 * 最小初始响应距离
 */
export const minStartTouchOffset: number = 10;

/**
 * 默认背景透明度
 */
export const defaultOpacity: number = 1;

/**
 * 最小缩放度
 */
export const minScale: number = 1;

/**
 * 最大缩放度（若图片足够大，则会超出）
 */
export const maxScale: number = 6;

/**
 * 滑动加速度
 */
export const slideAcceleration: number = 0.005;

/**
 * 缩放弹性缓冲
 */
export const scaleBuffer: number = 0.2;
